import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import StoreX, { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';
import { FormatDate } from '../../utils/Tools';
import Icon, { IconType } from '../Icon/Icon';
import Modal from '../Modal/Modal';
import InvoiceNewEditor from './InvoiceNewEditor';
import { IInvoice, IInvoicesInfo } from './OrganizationTypes';

const Invoices = () => {
  const [info, setInfo] = useState<IInvoicesInfo>();
  const [showNewInvoice, setShowNewInvoice] = useState<boolean>(false);

  useEffect(() => {
    init();
  }, []);

  const init = () => {
    store.server.getApi<ServerResponse<IInvoicesInfo>>(`../OrganizationData/Invoices`).then((x) => {
      if (x.Success) {
        setInfo(x.Value);
      } else {
        toast.error(x.Message, { autoClose: false });
      }
    });
  };

  const buildInvoiceBlip = (x: IInvoice, i: number) => {
    let link = StoreX.BuildUrl(`../app/organization/invoice/${x.PublicId}`);
    const declined = !!x.DeclinedAtUtc && !x.PaidAtUtc;
    return (
      <div className={`flex-between invoice ${x.PaidAtUtc ? 'paid' : ''} ${declined ? 'declined' : ''}`} key={`i-k-${i}`}>
        <div>
          <h3>{x.Organization.Name}</h3>
          <div>Amount: $ {(x.Amount ?? 0).toFixed(2)}</div>
          {x.RenewalBatchId && <div>Renewal batch {x.RenewalBatchId}</div>}

          <div>
            <a className="btn btn-info" href={link} target={'_blank'}>
              <Icon type={IconType.invoice} />
              View Invoice
            </a>
          </div>
        </div>
        {x.PaidAtUtc && (
          <div className="alert alert-success">
            <h4>Paid</h4>
            <div>
              {x.Type} Payment at {FormatDate(x.PaidAtUtc)}
              {x.PaymentId && <div>Payment Auth: {x.PaymentId}</div>}
            </div>
          </div>
        )}
        {declined && (
          <div className="alert alert-warning">
            <h4>Declined</h4>
            <div>
              {x.DeclineType === 'NotRenewing' ? 'Not renewing' : x.DeclineType === 'NotNeeded' ? 'Invoice not needed' : 'Declined'}
              {x.DeclinedAtUtc && <> · {FormatDate(x.DeclinedAtUtc)}</>}
            </div>
          </div>
        )}
        <div className="text-right">
          <div className="large">
            {x.Type} # {x.Id}
          </div>
          <div>
            {x.Type} Date: {FormatDate(x.CreatedAtUtc)}
          </div>
          {x.DueAtUtc && <div>Due: {FormatDate(x.DueAtUtc)}</div>}
          {x.SubscriptionValidThruUtc && (
            <div>Subscription through {FormatDate(x.SubscriptionValidThruUtc, 'date', true)}</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="org-invoices">
        <div className="flex-between">
          <h3>Invoices</h3>
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => {
                setShowNewInvoice(true);
              }}>
              <Icon type={IconType.fileInvoice} /> New Invoice
            </button>
          </div>
        </div>
        {info?.IsOwner && (
          <p>Renewal invoices for every organization, and invoice reminder emails, are sent from Overseer.</p>
        )}
        <hr />

        {(info?.Invoices?.length ?? 0) > 0 && (
          <div className="invoices-list">
            {info?.Invoices.map((x, i) => {
              return buildInvoiceBlip(x, i);
            })}
          </div>
        )}
      </div>

      {showNewInvoice && info && (
        <Modal setModalOpen={setShowNewInvoice} title={'New Order'} size="xl">
          <div className="form-horizontal">
            <strong>Event Size: {info.EventSize ?? "Unknown"}</strong>
            <InvoiceNewEditor
              onUpdated={(invoice:IInvoice)=>{
                setInfo({...info, Invoices: [invoice, ...info.Invoices]});
                setShowNewInvoice(false);
              }}
              invoice={{}}
              isOwner={info.IsOwner}
              products={info.Products}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default Invoices;
